import { render, staticRenderFns } from "./SKU.vue?vue&type=template&id=90f0bf70&scoped=true"
import script from "./SKU.vue?vue&type=script&lang=js"
export * from "./SKU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f0bf70",
  null
  
)

export default component.exports